import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import RequirePermissions from "@saleor/components/RequirePermissions";
import { PermissionEnum } from "@saleor/types/globalTypes";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    buttonAction: {
      margin: theme.spacing(0, 2)
    },
    buttonReturn: {
      marginRight: theme.spacing(2)
    }
  }),
  { name: "PayoutReviewButton" }
);

interface PayoutReviewButtonDialogProps {
  user: any;
  payoutStatus: string;
  onReview: (updateTo: string) => void;
}

export const PayoutReviewButtonDialog: React.FC<PayoutReviewButtonDialogProps> = ({
  user,
  payoutStatus,
  onReview
}) => {
  const classes = useStyles({});

  return (
    <>
      {payoutStatus === "Schedule for Payout" || payoutStatus === "Returned" ? (
        <RequirePermissions
          requiredPermissions={[PermissionEnum.MANAGE_PAYOUT_OPEN_ORDER]}
          userPermissions={user.userPermissions}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={() => onReview("ON_PROCESS")}
            className={classes.buttonAction}
          >
            <FormattedMessage defaultMessage="SUBMIT" description="button" />
          </Button>
        </RequirePermissions>
      ) : payoutStatus === "On Process" ? (
        <RequirePermissions
          requiredPermissions={[PermissionEnum.MANAGE_PAYOUT_ON_PROCESS]}
          userPermissions={user.userPermissions}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={() => onReview("FOR_PAYMENT")}
            className={classes.buttonAction}
          >
            <FormattedMessage defaultMessage="APPROVE" description="button" />
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => onReview("RETURNED")}
            className={classes.buttonReturn}
          >
            <FormattedMessage defaultMessage="RETURN" description="button" />
          </Button>
        </RequirePermissions>
      ) : payoutStatus === "For Payment" ? (
        <RequirePermissions
          requiredPermissions={[PermissionEnum.MANAGE_PAYOUT_PAYABLES]}
          userPermissions={user.userPermissions}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={() => onReview("PAYMENT_PROCESSING")}
            className={classes.buttonAction}
          >
            <FormattedMessage defaultMessage="APPROVE" description="button" />
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => onReview("RETURNED")}
            className={classes.buttonReturn}
          >
            <FormattedMessage defaultMessage="RETURN" description="button" />
          </Button>
        </RequirePermissions>
      ) : payoutStatus === "Payment processing" ? (
        <RequirePermissions
          requiredPermissions={[PermissionEnum.MANAGE_PAYOUT_PAYMENT]}
          userPermissions={user.userPermissions}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={() => onReview("READY_FOR_PAYMENT")}
            className={classes.buttonAction}
          >
            <FormattedMessage defaultMessage="APPROVE" description="button" />
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => onReview("RETURNED")}
            className={classes.buttonReturn}
          >
            <FormattedMessage defaultMessage="RETURN" description="button" />
          </Button>
        </RequirePermissions>
      ) : payoutStatus === "Ready for payment" ? (
        <RequirePermissions
          requiredPermissions={[PermissionEnum.MANAGE_PAYOUT_PAYMENT]}
          userPermissions={user.userPermissions}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={() => onReview("COMPLETED")}
            className={classes.buttonAction}
          >
            <FormattedMessage defaultMessage="COMPLETE" description="button" />
          </Button>
        </RequirePermissions>
      ) : (
        <></>
      )}
    </>
  );
};

export default PayoutReviewButtonDialog;
